import { Box, Typography, Grid } from '@mui/material'
import type { TDistributionDetails } from '@modules/types'
import { sectionTitleSx, componentCardSx, componentFieldLabelSx, fieldValueSx } from '../styles'

interface ComponentsSectionProps {
  lines: TDistributionDetails[]
}

const ComponentField = ({ label, value }: { label: string; value: string | number | null }) => (
  <Grid size={6}>
    <Typography sx={componentFieldLabelSx}>{label}</Typography>
    <Typography sx={fieldValueSx}>{value ?? 'N/A'}</Typography>
  </Grid>
)

export const ComponentsSection = ({ lines }: ComponentsSectionProps) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography sx={sectionTitleSx}>Components ({lines.length})</Typography>
      <Box>
        {lines.map(line => (
          <Box key={line.id} sx={componentCardSx}>
            <Grid container spacing={2}>
              <ComponentField label="Product Type" value={line.publicationType} />
              <ComponentField label="Number of Units (Copies)" value={line.numberOfUnits} />
              <ComponentField label="Net Retail Price" value={line.retailPrice} />
              <ComponentField label="Number of Songs" value={line.totalNumberOfWorks} />
              <ComponentField
                label="Number of Licensed Songs"
                value={line.numberOfCopyrightedWorks}
              />
            </Grid>
          </Box>
        ))}
      </Box>
    </Box>
  )
}
